import {Tooltip} from "primereact/tooltip";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

export default function SetEmptyIcon({onValueChange}) {
    const ref = useRef(null);

    const [mounted, setMounted] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        if (ref.current && !mounted) {
            setMounted(true); // Trigger a re-render when ref is assigned
        }
    }, [mounted]);

    const setEmpty = () => {
        onValueChange("empty", null);
    };

    return (
        <>
            <Tooltip target={ref.current} className="custom-tooltip" />
            <i
                ref={ref}
                className="pi pi-times-circle tooltip-icon text-blue-500 cursor-pointer"
                data-pr-tooltip={t("object.inputSetEmptyTooltip")}
                data-pr-position="top"
                onClick={() => setEmpty()}
            />
        </>
    );
}
